import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Edit, FormTab, TabbedForm } from 'react-admin';
import { FormSpy } from 'react-final-form';

import EditToolbar from '../../core/components/edit/EditToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import { getInitials, removePathEnd } from '../../core/utils';
import PresetSummary from './PresetSummary';

const styles = () => ({
  gridTab: {
    marginTop: '-17px !important'
  },
  noActions: {
    marginTop: '0px'
  }
});

const PresetTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.presetName}
      status={record.status}
      statusLabel="Status:"
      showAvatar={true}
      avatarContent={getInitials(record.presetName)}
    />
  );
};

class PresetEdit extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  onBeforeDelete = () => {
    // Unblock navigation before deleting
    this.setState({
      whenBlockNavigation: false
    });
  };

  handleFormIsDirty(dirty) {
    // Block navigation if the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }

  render() {
    const { whenBlockNavigation } = this.state;
    const {
      classes,
      hasCreatePermission,
      hasEditPermission,
      hasDeletePermission,
      userProfile,
      ...rest
    } = this.props;
    const displayToolbar = this.props.match.isExact;

    return (
      <React.Fragment>
        <NavigationPrompt
          when={whenBlockNavigation}
          adjustMatchingPath={removePathEnd}
          hasEditPermission={hasEditPermission}
        >
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Edit
          {...rest}
          undoable={false}
          title={<PresetTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <TabbedForm
            toolbar={
              displayToolbar ? (
                <EditToolbar
                  {...rest}
                  hasEditPermission={hasEditPermission}
                  hasDeletePermission={hasDeletePermission}
                  onBeforeDelete={this.onBeforeDelete}
                />
              ) : (
                <></>
              )
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Document Profile Details">
              <PresetSummary creation={false} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  const self = this;
                  setTimeout(() => self.handleFormIsDirty(props.dirty), 1);
                }}
              />
            </FormTab>
          </TabbedForm>
        </Edit>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PresetEdit);
